import React, { useEffect ,Suspense} from 'react'
////import ContactInfo from '../components/contact/ContactInfo'
const ContactInfo = React.lazy(() => import('../components/contact/ContactInfo'));
//import ContactForm from '../components/contact/ContactForm'
const ContactForm = React.lazy(() => import('../components/contact/ContactForm'));
//import Map from '../components/contact/Map'
const Map = React.lazy(() => import('../components/contact/Map'));
import { useAppContext } from '../Context/Store';

export default function Contact({ sendBodyClass }) {
  //const contextData = useAppContext();  
  const { isError, isLoading, ContactData } = useAppContext(); 


  if(isError){
    //console.log("Home Page Component", contextData);
    return <div>Error Contact Page...</div>;  // Handle Error state
  }

  if (!ContactData || isLoading) {
    return <div>Loading...</div>;  // Handle loading state
  }
  // if(contextData.isLoading){
  //   return <div>Loading...</div>;
  // }

  //console.log("About Page Component", contextData);

  const { properties } = ContactData;
  //console.log("About Page Component", properties);

  //console.log(properties?.leftText?.markup);
  //console.log(properties?.rightImage);

  useEffect(() => {
    sendBodyClass(false);
  },[])
  return (
    <>
     <Suspense fallback={<div>Loading...</div>}>
        <section className="hero-box map">
            <div className="inner">
                <Map MapEmbedCodeDataDynamic={properties?.mapEmbedCode || "Embed Map Data Missing"} />
            </div>
        </section> 

        <section className="about-txt contact">
                <div className="inner">
                    <article>
                        <ContactInfo 
                          ContactUsLeftTextDataDynamic={properties?.contactUsLeftText?.markup || "Contact Us Left Text Data Missing"}
                          CallUsLabelTextDataDynamic={properties?.callUsLabelText || "Call Us Label Text Data Missing"}
                          CallUsTextDataDynamic={properties?.callUsText || "Call Us Text Data Missing"}
                          CallUsShortIntroDataDynamic={properties?.callUsShortIntro || "Call Us Short Intro Data Missing"}
                          PhoneDataDynamic={properties?.phone || "Phone Data Missing"} 
                          CustomerSupportLabelTextDataDynamic={properties?.customerSupportLabelText || "Customer Support Label Text Data Missing"}
                          CustomerSupportTextDataDynamic={properties?.customerSupportText || "Customer Support Text Data Missing"}
                          CustomerSupportShortIntroDataDynamic={properties?.customerSupportShortIntro || "Customer Support Short Intro Data Missing"}
                          CustomerSupportChatTextDataDynamic={properties?.customerSupportChatText || "Customer Support Chat Text Data Missing"}
                          EmailLabelTextDataDynamic={properties?.emailLabelText || "Email Label Text Data Missing"}
                          EmailTextDataDynamic={properties?.emailText || "Email Text Data Missing"}
                          EmailShortIntroDataDynamic={properties?.emailShortIntro || "Email Short Intro Data Missing"}
                          EmailDataDynamic={properties?.email || "Email Data Missing"}
                          AddressLabelTextDataDynamic={properties?.addressLabelText || "Address Label Text Data Missing"}
                          AddressTextDataDynamic={properties?.addressText || "Address Text Data Missing"}
                          AddressDataDynamic={properties?.address || "Address Data Missing"}
                          AddressPhoneDataDynamic={properties?.addressPhone || "Address Phone Data Missing"}
                        />
                    </article>
                    <article className="right-side-contact">
                        <ContactForm GetInTouchRightTextDataDynamic={properties?.getInTouchRightText?.markup || "Get in Touch Right Text Data Missing"} />
                      </article>
                    </div>
            </section> 
            </Suspense>
    </>
  )
}
